export default {
  loading: false,
  showWindow: false,
  passwordReset: false,
  error: false,
  errorMessage: null
}